import * as React from 'react';
import { connect } from 'react-redux';
import { navigate } from 'router';
import { createRouteNodeSelector } from 'redux-router5';

import CurrentOrgInjector from '~/apps/shared/containers/app/CurrentOrgInjector';
import LocationListComp from '~/apps/shared/containers/locations/OrgLocationList';
import { parseLocationFilter } from '~/apps/shared/services/qsfilter';


const LocationList = (props) => {
  const { route: { params } } = props;
  const filter = parseLocationFilter(params);

  return (
    <CurrentOrgInjector
      component={LocationListComp}
      editLabel="View Transactions"
      filter={filter}
      onClick={(locationId) => {
        navigate('receiver.admin.transactions', {locationId});
      }}
    />
  );
}

export default connect(createRouteNodeSelector('receiver.admin'))(LocationList);
